import type { SmsTemplate } from 'types';
import { baseQuery } from '../baseQuery';

export const getTaskSmsTemplates = async () => {
  const { data } = await baseQuery('sms-templates?per_page=100');

  return (data ?? []) as SmsTemplate[];
};
